var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "050-calendar",
    clipPath: "url(#clip0_2649_21995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M95.6518 9.06934H12.3404C10.0006 9.06934 8.10156 10.9684 8.10156 13.3081V100.768C8.10156 103.108 10.0006 105.007 12.3404 105.007H95.6518C97.9915 105.007 99.8906 103.108 99.8906 100.768V13.3081C99.8906 10.9684 97.9919 9.06934 95.6518 9.06934Z",
    fill: "url(#paint0_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M95.6579 105.006H12.3482C10.0072 105.006 8.10938 103.109 8.10938 100.767V54.8477H99.8967V100.767C99.8967 103.109 97.9989 105.006 95.6579 105.006Z",
    fill: "url(#paint1_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M95.6579 105.006H12.3482C10.0072 105.006 8.10938 103.109 8.10938 100.768V91.8662H99.8967V100.768C99.8967 103.109 97.9989 105.006 95.6579 105.006Z",
    fill: "url(#paint2_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M103.759 94.6923H4.24051C1.51773 94.6923 -0.498837 92.1619 0.108663 89.5079L8.10615 54.5654H99.8935L107.891 89.5079C108.498 92.1619 106.482 94.6923 103.759 94.6923Z",
    fill: "url(#paint3_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M103.759 94.6923H4.24051C1.51773 94.6923 -0.498837 92.1619 0.108663 89.5079L8.10615 54.5654H99.8935L107.891 89.5079C108.498 92.1619 106.482 94.6923 103.759 94.6923Z",
    fill: "url(#paint4_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M103.762 94.6923C106.485 94.6923 108.501 92.1619 107.894 89.5079L99.8965 54.5654H8.10938L48.2362 94.6923H103.762Z",
    fill: "url(#paint5_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M99.8967 94.6924H8.10938V94.8337L18.2823 105.007H95.6579C97.9989 105.007 99.8967 103.109 99.8967 100.768V94.6924Z",
    fill: "url(#paint6_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M32.0938 62.9727V45.0892C32.0938 40.3783 33.3429 36.9155 35.8425 34.7032C38.3411 32.4907 41.6809 31.3848 45.8595 31.3848C50.0384 31.3848 53.3879 32.4909 55.9075 34.7032C58.4272 36.9158 59.6869 40.3781 59.6869 45.0892V62.9727C59.6869 67.6846 58.4272 71.1463 55.9075 73.3586C53.3877 75.5711 50.0386 76.6771 45.8595 76.6771C41.6806 76.6771 38.3409 75.5709 35.8425 73.3586C33.3431 71.1461 32.0938 67.6844 32.0938 62.9727ZM38.6081 62.9727C38.6081 68.2579 41.0251 70.9005 45.86 70.9005C48.1952 70.9005 49.9977 70.2456 51.268 68.9338C52.5374 67.6232 53.1729 65.6364 53.1729 62.9727V45.0892C53.1729 42.4265 52.5374 40.4395 51.268 39.1281C49.9977 37.8175 48.1952 37.1613 45.86 37.1613C41.0251 37.1613 38.6081 39.8039 38.6081 45.0892V62.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M63.6797 40.6646C63.6797 39.5996 64.1096 38.7596 64.9702 38.1447L71.3616 31.9993C71.8118 31.5489 72.365 31.3232 73.0208 31.3232C73.7585 31.3232 74.4238 31.5184 75.0182 31.9071C75.6118 32.2967 75.9092 32.8192 75.9092 33.4742V74.1575C75.9092 74.8133 75.5808 75.3358 74.926 75.7245C74.2702 76.1141 73.5125 76.3084 72.6521 76.3084C71.7504 76.3084 70.9821 76.1146 70.3476 75.7245C69.7121 75.3356 69.395 74.8133 69.395 74.1575V39.9883L67.2441 42.6924C66.8343 43.1022 66.3837 43.3068 65.892 43.3068C65.2775 43.3068 64.755 43.0303 64.3249 42.4772C63.8946 41.9243 63.6797 41.3204 63.6797 40.6646Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M53.1717 54.5654V62.9723C53.1717 65.6371 52.5387 67.6237 51.2671 68.9349C49.9983 70.2463 48.1955 70.9017 45.8612 70.9017C41.0261 70.9017 38.6073 68.2565 38.6073 62.9726V54.5656H32.0938V62.9726C32.0938 67.6862 33.3427 71.1476 35.8436 73.3574C38.3415 75.5702 41.6819 76.6778 45.8612 76.6778C50.038 76.6778 53.3894 75.5702 55.9071 73.3574C58.4278 71.1476 59.688 67.686 59.688 62.9726V54.5656L53.1717 54.5654Z",
    fill: "url(#paint7_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M69.3984 54.5654V74.1571C69.3984 74.8127 69.7151 75.3354 70.3506 75.7254C70.9836 76.1154 71.7521 76.3074 72.6536 76.3074C73.5155 76.3074 74.273 76.1152 74.9284 75.7254C75.584 75.3354 75.9118 74.8127 75.9118 74.1571V54.5654H69.3984Z",
    fill: "url(#paint8_linear_2649_21995)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M107.889 89.507L99.892 54.5654V13.3081C99.892 10.9684 97.9929 9.06934 95.6532 9.06934H93.6484C95.9882 9.06934 97.8872 10.9684 97.8872 13.3081V54.5654L105.884 89.507C106.492 92.1633 104.474 94.6923 101.753 94.6923H103.758C106.479 94.6925 108.497 92.1631 107.889 89.507Z",
    fill: "url(#paint9_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M36.0389 16.6201C35.2673 15.8968 34.7812 14.8737 34.7812 13.7319V9.06934H42.6935L49.1554 15.5312C51.215 17.5908 52.3722 20.3844 52.3722 23.2973C52.3722 25.4311 50.7304 27.2663 48.5987 27.3627C47.3837 27.4175 46.2898 26.9216 45.5281 26.1095L36.0389 16.6201Z",
    fill: "url(#paint10_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M38.7374 17.6875C36.5525 17.6875 34.7812 15.9162 34.7812 13.7314V6.9493C34.7812 4.76441 36.5525 2.99316 38.7374 2.99316C40.9223 2.99316 42.6935 4.76441 42.6935 6.9493V13.7311C42.6935 15.9162 40.9223 17.6875 38.7374 17.6875Z",
    fill: "url(#paint11_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M38.7422 2.99316V17.6875C40.9271 17.6875 42.6983 15.9162 42.6983 13.7314V6.9493C42.6983 4.76441 40.9271 2.99316 38.7422 2.99316Z",
    fill: "url(#paint12_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M64.7967 16.6201C64.0251 15.8968 63.5391 14.8737 63.5391 13.7319V9.06934H71.4513L77.9132 15.5312C79.9728 17.5908 81.13 20.3844 81.13 23.2973C81.13 25.4311 79.4883 27.2663 77.3565 27.3627C76.1415 27.4175 75.0476 26.9216 74.2859 26.1095L64.7967 16.6201Z",
    fill: "url(#paint13_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M67.4952 17.6875C65.3103 17.6875 63.5391 15.9162 63.5391 13.7314V6.9493C63.5391 4.76441 65.3103 2.99316 67.4952 2.99316C69.6801 2.99316 71.4513 4.76441 71.4513 6.9493V13.7311C71.4513 15.9162 69.6799 17.6875 67.4952 17.6875Z",
    fill: "url(#paint14_linear_2649_21995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M67.4922 2.99316V17.6875C69.6771 17.6875 71.4483 15.9162 71.4483 13.7314V6.9493C71.4483 4.76441 69.6769 2.99316 67.4922 2.99316Z",
    fill: "url(#paint15_linear_2649_21995)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2649_21995",
    x1: 38.0257,
    y1: 21.5429,
    x2: 62.4817,
    y2: 75.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2649_21995",
    x1: 22.6369,
    y1: 44.7297,
    x2: 85.6591,
    y2: 112.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97AAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2649_21995",
    x1: 54.0047,
    y1: 103.81,
    x2: 54.0047,
    y2: 94.4092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2649_21995",
    x1: 14.5777,
    y1: 57.9479,
    x2: 115.696,
    y2: 103.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2649_21995",
    x1: 54.0015,
    y1: 90.8295,
    x2: 54.0015,
    y2: 96.4817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#008BF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2649_21995",
    x1: 73.1752,
    y1: 73.7338,
    x2: 9.11319,
    y2: 9.67205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#008BF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2649_21995",
    x1: 47.2656,
    y1: 86.4197,
    x2: 36.7691,
    y2: 73.4256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2649_21995",
    x1: 45.8921,
    y1: 61.7768,
    x2: 45.8921,
    y2: 29.5266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2649_21995",
    x1: 72.6575,
    y1: 61.7768,
    x2: 72.6575,
    y2: 29.5265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2649_21995",
    x1: 99.9918,
    y1: 51.615,
    x2: 78.3686,
    y2: 57.2672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#008BF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2649_21995",
    x1: 46.8168,
    y1: 20.2921,
    x2: 38.4398,
    y2: 11.9153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#008BF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2649_21995",
    x1: 38.7385,
    y1: 3.19274,
    x2: 38.7385,
    y2: 48.5456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FFA801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2649_21995",
    x1: 39.378,
    y1: 10.3369,
    x2: 42.9466,
    y2: 10.3369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2649_21995",
    x1: 75.5756,
    y1: 20.2921,
    x2: 67.1986,
    y2: 11.9153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#008BF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2649_21995",
    x1: 67.4973,
    y1: 3.19274,
    x2: 67.4973,
    y2: 48.5456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FFA801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2649_21995",
    x1: 68.131,
    y1: 10.3369,
    x2: 71.6974,
    y2: 10.3369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2649_21995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAppointment);
export default __webpack_public_path__ + "static/media/calendarAppointment.4cc7ed8427002925ecdcce8dae4cfc7f.svg";
export { ForwardRef as ReactComponent };